import { Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'app-sales-order-transfer-deposit-dialog',
  templateUrl: './sales-order-transfer-deposit-dialog.component.html',
  styleUrls: ['./sales-order-transfer-deposit-dialog.component.scss']
})
export class SalesOrderTransferDepositDialogComponent implements OnInit {
  mode: string = 'SEARCH';
  stores: any[] = [];
  searchForm: FormGroup;
  form: FormGroup;

  validateResponse: any = null;

  busy: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SalesOrderTransferDepositDialogComponent>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: {
      salesOrderNumber: string;
    },
    private baseService: BaseService,
    private dialog: MatDialog,
    private helperService: HelperService,
  ) {
    this.searchForm = fb.group({
      fromSalesOrderNumber: [data.salesOrderNumber, Validators.compose([Validators.required])],
      toSalesOrderNumber: [null, Validators.compose([Validators.required])],
      storeId: [null, Validators.compose([Validators.required])]
    });

    this.form = fb.group({
      fromSalesOrderNumber: [null, Validators.compose([Validators.required])],
      toSalesOrderNumber: [null, Validators.compose([Validators.required])],
      storeId: [null, Validators.compose([Validators.required])],
      amountToTransfer: [null, Validators.compose([Validators.required])],
      approvedByEmail: [null, Validators.compose([Validators.required])],
      approvedByPwd: [null, Validators.compose([Validators.required])],
    });

    this.searchForm.controls['fromSalesOrderNumber'].disable();
    // this.searchForm.controls['storeId'].setValue(this.stores[0].storeId);
  }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_syspro_order_transfer_deposit_dialog_config', this.searchForm.getRawValue())
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.stores = response.data.stores;
          if (this.stores && this.stores.length === 1) {
            this.searchForm.controls['storeId'].setValue(this.stores[0].storeId);
          }
        }
      });
  }

  setBusy(isBusy: boolean) {
    this.busy = isBusy;
    if (isBusy) {
      this.searchForm.disable();
      this.form.disable();
    } else {
      this.searchForm.enable();
      this.form.enable();
      this.searchForm.controls['fromSalesOrderNumber'].disable();
    }
  }

  validate() {
    this.form.reset();
    this.setBusy(true);
    this.validateResponse = null;
    this.baseService.executeCommand<any>('portal_syspro_order_transfer_deposit_dialog_validate', this.searchForm.getRawValue())
      .subscribe(
        response => {
          if (response.responseCode === 0) {
            this.validateResponse = response.data;
            if (this.validateResponse.transferAlllowed) {
              this.form.patchValue(this.searchForm.value);
              this.form.controls['amountToTransfer'].setValue(this.validateResponse.maxTransferAmount);
              this.form.controls['amountToTransfer'].setValidators(Validators.compose([Validators.required, Validators.min(0.01), Validators.max(this.validateResponse.maxTransferAmount)]));
            }
          }
          this.setBusy(false);
        }),
      error => {
        this.setBusy(false);
      };
  }

  save() {
    let body = this.form.getRawValue();
    body.approvedByPwd = this.helperService.hash(body.approvedByPwd);
    this.setBusy(true);
    this.baseService.executeCommand<any>('portal_syspro_order_transfer_deposit', body)
      .subscribe(
        response => {
          this.setBusy(false);
          if (response.responseCode === 0) {
            this.dialogRef.close(true);
          }
        },
        error => {
          this.setBusy(false);
        });
  }

}
